@if (isLoading()) {
  <lib-loader />
} @else {
  <lib-dropdown
    data-test="focus-measure-selector"
    [options]="availableMeasures()"
    [model]="focusMeasure()"
    (modelChange)="updateFocusMeasure($event)"
    label="Focus Measure"
    labelKey="fullName"
  />
}
